// eslint-disable-next-line no-use-before-define
import React, { Fragment, useContext } from 'react';
import { Switch, Route } from 'react-router-dom';
import ROPatientDiagnosisPrimaryOrMetastasis from './DiagnosisPrimaryOrMetastasis';
import ROPatientDiagnosisSelectionPage from './DiagnosisSelectionPage';
import ROPatientDiagnosisICD10Page from './ICD10Page';
import ROPatientDiagnosisIntakePage from './Intake/IntakePage';
import StagingPageRouter from './Staging/StagingPageRouter';
import ROPatientSimpleDiagnosisSelection from './SimpleDiagnosisSelection/SimpleDiagnosisSelection';
import { CAREPLAN_PAGES } from '../Constants';
import UserContext from 'op-contexts/UserContext/UserContext';

interface DiagRouterProps {
  onDataRefresh: any;
}

const ROPatientDiagnosisRouter = (props: DiagRouterProps): JSX.Element => {
  const userContext = useContext(UserContext);
  const { hasFeature, isFeatureLoading, state } = userContext;
  const isSimpleDiagnosisSelectionEnabled = hasFeature('SimpleDiagnosisSelection');
  // TODO: This is a hack to prevent the page from rendering before the features are loaded.
  // Can have issues if none of the features are enabled.
  if (isFeatureLoading()) {
    return <></>;
  }

  return (
    <Fragment>
      <Switch>
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/diagnosis/:diagnosisId/${CAREPLAN_PAGES.INTAKE}`}
          component={ROPatientDiagnosisIntakePage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/diagnosis/:diagnosisId/${CAREPLAN_PAGES.STAGING}`}>
          <StagingPageRouter onDataRefresh={props.onDataRefresh} />
        </Route>
        {isSimpleDiagnosisSelectionEnabled && (
          <Route
            path="/:oncologyType/patient/:id/careplan/:careplanId/(diagnosis)?/:diagnosisId?"
            component={ROPatientSimpleDiagnosisSelection}
          />
        )}
        <Route
          path="/:oncologyType/patient/:id/careplan/:careplanId/diagnosis/:diagnosisId/:page/:operation"
          component={ROPatientDiagnosisICD10Page}
        />
        <Route
          path="/:oncologyType/patient/:id/careplan/:careplanId/diagnosis/:diagnosisId/:page"
          component={ROPatientDiagnosisSelectionPage}
        />
        <Route
          path="/:oncologyType/patient/:id/careplan/:careplanId/(diagnosis)?/:diagnosisId?"
          component={ROPatientDiagnosisPrimaryOrMetastasis}
        />
      </Switch>
    </Fragment>
  );
};

export default ROPatientDiagnosisRouter;
